import React from 'react';
import { useIsMobile } from '../../hooks/useDeviceType';
import PortalLayout from './PortalLayout';
import MobilePortalLayout from './MobilePortalLayout';
import StaffLayout from './StaffLayout';
import MobileStaffLayout from './MobileStaffLayout';

/**
 * Responsive layout wrapper that renders the appropriate layout based on device type
 * Uses MobilePortalLayout for mobile devices with bottom navigation
 * Uses PortalLayout for desktop devices with sidebar navigation
 */

// Client Portal Responsive Layout
export const ResponsivePortalLayout = ({ children, ...props }) => {
  const isMobile = useIsMobile();
  
  console.log('🔍 ResponsivePortalLayout - isMobile:', isMobile, 'window.innerWidth:', window.innerWidth);
  
  if (isMobile) {
    console.log('✅ Rendering MobilePortalLayout with bottom navigation');
    return <MobilePortalLayout {...props}>{children}</MobilePortalLayout>;
  }
  
  console.log('✅ Rendering Desktop PortalLayout with sidebar');
  return <PortalLayout {...props}>{children}</PortalLayout>;
};

// Staff Portal Responsive Layout
export const ResponsiveStaffLayout = ({ children, ...props }) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileStaffLayout {...props}>{children}</MobileStaffLayout>;
  }
  
  return <StaffLayout {...props}>{children}</StaffLayout>;
};

// Main Layout Responsive Wrapper (for landing pages, etc.)
export const ResponsiveMainLayout = ({ children, ...props }) => {
  const isMobile = useIsMobile();

  // For now, we'll use the same layout for both mobile and desktop
  // This can be extended later if needed for landing pages
  return <div {...props}>{children}</div>;
};

export default {
  ResponsivePortalLayout,
  ResponsiveStaffLayout,
  ResponsiveMainLayout
};
